import React from 'react'
import { Collapse, List } from 'antd'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { getTransformedDate } from 'src/core/helpers'
import { CalculateResultsType } from 'src/core/models'

const CalculateResultsMovileViewColumn: React.FC<{ calculus: CalculateResultsType }> = ({ calculus }) => {
  const { t } = useTranslation()

  const labels = [
    { label: 'Cabify.Date', value: getTransformedDate(calculus.date) },
    { label: 'Cabify.ClientName', value: calculus.client_name },
    { label: 'Cabify.KmDistance', value: calculus.km_distance },
    { label: 'Cabify.Footprint', value: calculus.footprint },
    { label: 'Cabify.Period', value: calculus.period },
    { label: 'Cabify.Mean', value: calculus.mean },
    { label: 'Cabify.Ratio', value: calculus.ratio },
    { label: 'Cabify.Diff', value: calculus.diff },
  ]

  return (
    <Collapse defaultActiveKey={[]} ghost expandIconPosition='end'>
      <Collapse.Panel header={getTransformedDate(calculus.date)} key='1'>
        <List dataSource={labels}
          renderItem={item => (
            <List.Item>
              <React.Fragment>
                <CustomText label={t(item.label)} type='secondary' />
                <CustomText label={item.value} type={null} />
              </React.Fragment>
            </List.Item>
          )}
        />
      </Collapse.Panel>
    </Collapse>

  )
}

export default CalculateResultsMovileViewColumn
